import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AlertCircle, ArrowRight } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface PendingOrdersBadgeProps {
  count: number
  className?: string
}

export function PendingOrdersBadge({ count, className }: PendingOrdersBadgeProps) {
  const { t } = useTranslation('dashboard')

  if (count === 0) {
    return null
  }

  return (
    <div
      className={cn(
        'flex items-center justify-between p-4 rounded-lg border border-amber-300 bg-amber-50',
        className
      )}
    >
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-full bg-amber-200 flex items-center justify-center">
          <AlertCircle className="h-5 w-5 text-amber-700" />
        </div>
        <div>
          <p className="font-medium text-amber-900">
            {t('pending.title', { count })}
          </p>
          <p className="text-sm text-amber-700">{t('pending.description')}</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Badge variant="secondary" className="bg-amber-200 text-amber-800 hover:bg-amber-200">
          {count}
        </Badge>
        <Button asChild variant="ghost" size="sm" className="text-amber-700 hover:text-amber-800 hover:bg-amber-100">
          <Link to="/orders">
            {t('pending.viewOrders')}
            <ArrowRight className="ml-1 h-4 w-4" />
          </Link>
        </Button>
      </div>
    </div>
  )
}
